let env_type = process.env.NODE_ENV || 'production';

if (
	window.location.host.startsWith('dev') ||
	window.location.host.startsWith('viewers-ev') ||
	window.location.host.startsWith('app.sandbox') ||
	window.location.host.startsWith('dashboard.sandbox') ||
	window.location.host.startsWith('sandbox')
) {
	env_type = 'test';
} else if (window.location.host.startsWith('localhost')) {
	env_type = 'development';
}

if (process.env.REACT_APP_ARG === 'prod') {
	env_type = 'production';
}

const serverConfig = {
	development: {
		path: 'http://localhost',
		port: 4000,
	},
	test: {
		path: 'https://engine.eventovirtual.co',
		port: 4000,
	},
	production: {
		path: 'https://engine.eventovirtual.co',
		port: 443,
	},
};

export default serverConfig[env_type];
